import React, { useState, useEffect, useCallback, memo } from 'react';
import {
  Box,
  Icon,
  IconButton,
  ButtonBase,
  Menu,
  MenuItem,
  Typography,
} from '@material-ui/core';

import { convertObjToArr } from '../../../../../../../utils';
import Search from '../../../../../../../components/Search';
import useStyles from './styles';

const Filters = ({
  onBack,
  onSearch,
  onSelectArea,
  professionals,
  selectedProfessional,
}) => {
  const classes = useStyles();
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState(null);
  const [anchorAreaMenu, setAnchorAreaMenu] = useState(null);
  const [searchOpened, setSearchOpened] = useState(false);

  useEffect(() => {
    if (professionals.length) {
      const areasObj = professionals.reduce(
        (accumulator, { areaId, areaName }) => ({
          ...accumulator,
          [areaId]: {
            id: areaId,
            name: areaName,
          },
        }),
        {},
      );
      setAreas(convertObjToArr(areasObj));
    }
  }, [professionals]);

  const handleOpenAreaMenu = useCallback(event => {
    setAnchorAreaMenu(event.currentTarget);
  }, []);

  const handleCloseAreaMenu = useCallback(() => {
    setAnchorAreaMenu(null);
  }, []);

  const handleSelectArea = useCallback(
    area => {
      handleCloseAreaMenu();
      setSelectedArea(area?.name || null);
      onSelectArea(area?.id || null);
    },
    [handleCloseAreaMenu, onSelectArea],
  );

  const handleToggleSearch = useCallback(
    isOpened => {
      setSearchOpened(isOpened);
      if (isOpened) handleSelectArea(null);
    },
    [handleSelectArea],
  );

  useEffect(() => {
    if (selectedProfessional) {
      handleSelectArea(null);
    }
  }, [selectedProfessional, handleSelectArea]);

  return (
    <Box className={classes.container}>
      {selectedProfessional ? (
        <Box className="btn-back-container">
          <IconButton className="btn-back-button" onClick={onBack}>
            <Icon>arrow_back</Icon>
          </IconButton>
          <Typography variant="caption" className="btn-back-text">
            Voltar
          </Typography>
        </Box>
      ) : (
        <>
          <Search filterHandler={onSearch} toggleHandler={handleToggleSearch} />
          {!searchOpened && (
            <Box className="menu-areas">
              <ButtonBase
                onClick={handleOpenAreaMenu}
                className="menu-areas-btn"
              >
                <Typography className="menu-areas-btn-text" variant="body2">
                  {selectedArea || 'Todas as áreas'}
                </Typography>
                <Icon className="menu-areas-btn-icon">arrow_drop_down</Icon>
              </ButtonBase>
              <Menu
                anchorEl={anchorAreaMenu}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={!!anchorAreaMenu}
                onClose={handleCloseAreaMenu}
                className={classes.dropDownAreas}
              >
                <MenuItem>
                  <Typography
                    variant="overline"
                    className="menu-areas-dropdown-label"
                  >
                    Filtrar por área:
                  </Typography>
                </MenuItem>
                <MenuItem onClick={() => handleSelectArea(null)}>
                  <Typography variant="body2">Todas as áreas</Typography>
                </MenuItem>
                {areas.map(area => (
                  <MenuItem
                    key={area.id}
                    onClick={() => handleSelectArea(area)}
                  >
                    <Typography variant="body2">{area.name}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default memo(Filters);
